import { notFound } from "next/navigation"
import { ReactNode } from "react"
import { auth0 } from "../../../lib/auth0"

export const adminEmailAddresses = [
    "will@williampoynter.co.uk",
    "will+105@williampoynter.co.uk",
    "will@researchwiseai.com",
]

interface Props {
    children: ReactNode
}

export async function AdminOnly({ children }: Props) {
    const session = await auth0.getSession()

    const isAdmin = adminEmailAddresses.includes(session?.user.email?.toLowerCase() ?? "")

    if (!isAdmin) {
        console.warn("User is not an admin", session?.user)
        return notFound()
    }

    return <>{children}</>
}
